import manageInventoryActions from 'manage-inventory/actions/action-types';
import subordinateListActions from 'utils/rw-subordinates/actions/action-types';
import messagesActions from 'message/actions/action-types';
import sftpActions from 'report-subscriptions/actions/action-types';
import gameImagesActions from 'app/actions/game-images.actions';
import bigWinnersActions from 'dashboard/actions/big-winners/action-types';
import cumulativeWinnersActions from 'dashboard/actions/cumulative-winners/action-types';
import eftHistoryActions from 'dashboard/actions/eft-history/action-types';
import linkedRetailersActions from 'user/actions/linked-retailers.action-types';
import retailerReportsActions from 'retailer-reports/actions/action-types';
import adminReportsActions from 'admin-reports/actions/action-types';

export const createPaginationObject = (pagination) => {
  if (!pagination) return {};

  const { totalElements, totalPages, number, size, hasPrevious, hasNext } = pagination;
  const calculatePageNumber = (pageNumber) => pageNumber + 1;

  return {
    count: totalElements,
    pagesCount: totalPages,
    page: number,
    displayedPage: calculatePageNumber(number),
    pageSize: size,
    hasPreviousPage: hasPrevious,
    hasNextPage: hasNext,
  };
};

export default (state = {}, action) => {
  switch (action.type) {
    case manageInventoryActions.FETCH_GAMES_LIST_SUCCESS:
    case manageInventoryActions.FETCH_PACKS_LIST_SUCCESS:
    case manageInventoryActions.FETCH_LIABILITIES_SUCCESS:
    case manageInventoryActions.FETCH_INSTANT_GAMES_TRANSITIONS_HISTORY_SUCCESS:
    case manageInventoryActions.FETCH_ORDER_HISTORY_SUCCESS:
    case subordinateListActions.FETCH_SUBORDINATE_LIST_SUCCESS:
    case messagesActions.FETCH_MESSAGES_LIST_SUCCESS:
    case messagesActions.FETCH_SENT_MESSAGES_LIST_SUCCESS:
    case messagesActions.FETCH_RECIPIENTS_SUCCESS:
    case sftpActions.FETCH_SFTP_LIST_SUCCESS:
    case gameImagesActions.FETCH_GAME_IMAGES_SUCCESS:
    case bigWinnersActions.FETCH_BIG_WINNERS_HISTORY_SUCCESS:
    case cumulativeWinnersActions.FETCH_CUMULATIVE_WINNERS_HISTORY_SUCCESS:
    case eftHistoryActions.FETCH_EFT_HISTORY_SUCCESS:
    case linkedRetailersActions.FETCH_LINKED_RETAILERS_SUCCESS:
    case retailerReportsActions.FETCH_RETAILER_REPORTS_SUCCESS:
    case adminReportsActions.FETCH_USER_ACTIVITY_REPORTS_SUCCESS: {
      return createPaginationObject(action.pagination);
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/utils/reducers/pagination/pagination.js